import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axiosInstance';
import {
  errorResponseParser,
  successResponseParser,
} from '../../utils/handlers';

export const designationdetails = createAsyncThunk(
  'designationdetails',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const Employee_Id = JSON.parse(
        localStorage.getItem('userData')
      )?.employeeId;
      const company_id = JSON.parse(
        localStorage.getItem('userData')
      )?.companyId;
      const res = await axios.get(`/DesignationList`, {
        params: { Employee_Id, company_id },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const hierarchyDropdownList = createAsyncThunk(
  'hierarchyDropdownList',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const Employee_Id = JSON.parse(
        localStorage.getItem('userData')
      )?.employeeId;
      const company_id = JSON.parse(
        localStorage.getItem('userData')
      )?.companyId;
      const res = await axios.get(`/HierarchyDropdown`, {
        params: { Employee_Id, company_id },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const expenseReportDetails = createAsyncThunk(
  'expenseReportDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/ExpenseReport`, {
        params: data,
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const expenseDetailReportDetails = createAsyncThunk(
  'expenseDetailReportDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/ExpenseDetailReport`, {
        params: data,
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

const expenseReport = createSlice({
  name: 'expenseReport',
  initialState: {
    isLoading: false,
    desigdata: [],
    hierarchydropdown: [],
    expensedetails: [],
    detailedreport: [],
    //Submitdata:[],
    successMessage: '',
    apiError: '',
  },
  reducers: {
    clearExpenseReportData: (state) => {
      state.expensedetails = [];
      state.detailedreport = [];
    },
  },

  extraReducers: (builder) => {
    builder.addCase(designationdetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(designationdetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.desigdata = action.payload;
    });
    builder.addCase(designationdetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.desigdata = null;
    });

    builder.addCase(hierarchyDropdownList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(hierarchyDropdownList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.hierarchydropdown = action.payload;
    });
    builder.addCase(hierarchyDropdownList.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.hierarchydropdown = null;
    });

    builder.addCase(expenseReportDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(expenseReportDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.expensedetails = action.payload;
    });
    builder.addCase(expenseReportDetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.expensedetails = null;
    });

    builder.addCase(expenseDetailReportDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(expenseDetailReportDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.detailedreport = action.payload;
    });
    builder.addCase(expenseDetailReportDetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.detailedreport = null;
    });
  },
});
export const { clearExpenseReportData } = expenseReport.actions;
export default expenseReport.reducer;
